module.exports = __webpack_public_path__ + "static/media/challenge-trivia.685eb034.svg";